export const blockIconsCommunicationInboxNew = (
	<span className='material-symbols-outlined'>inbox</span>
);
